import { $get } from '../axios';

// 账号设置-修改手机
export const changePhone = params => {
  return $get('/creator/', { act: 'change_phone', op: 4, ...params });
};
// 账号权益
export const getAccEquity = params => {
  return $get('/creator/', { act: 'get_score_info', ...params });
};
//获取后台配置账号权益
// export const fetchRights = params => {
//   return $get('/creator/', { act: 'get_created_info', ...params });
// };
//获取创想值与等级配置
export const getAccountEquity = params => {
  return $get('/creator/', { act: 'get_created_info', ...params });
};
// 端内登录态换
export const getAuthConvert = params => {
  return $get('/', { act: 'auth_convert', ...params });
};
